import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./app.scss";
import FormPage from "./components/FormPage";
import ThankYouPage from "./components/ThankYouPage";
import "./assets/scss/cconsent-bar.css";

function App() {
    return (
        <BrowserRouter basename={process.env.PUBLIC_URL || "/newslettery/nowy_elroq"}>
            <Routes>
                <Route path="/dziekujemy" element={<ThankYouPage/>}/>
                <Route path="/" element={<FormPage/>}/>
            </Routes>
        </BrowserRouter>
    );
}
export default App;
